import { render, staticRenderFns } from "./modal-course-detail.vue?vue&type=template&id=6eb6892a&scoped=true"
import script from "./modal-course-detail.vue?vue&type=script&lang=js"
export * from "./modal-course-detail.vue?vue&type=script&lang=js"
import style0 from "./modal-course-detail.vue?vue&type=style&index=0&id=6eb6892a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb6892a",
  null
  
)

export default component.exports